import type { LucideIcon } from "lucide-react";

/**
 * Ação de largura cheia.
 *
 * Existe porque o app tem umas vinte ações desse tipo — "Agregar un artículo",
 * "Generar semana", "Cocinar ahora", "Verlo en Hotmart" — e antes desta peça
 * cada tela repetia os mesmos números de altura, fonte e cor na mão. Um botão
 * escrito à mão em seis arquivos é seis chances de nascer com 44px.
 *
 * Largura cheia e não lado a lado: dois botões dividindo 350px dão alvos de
 * 170px e obrigam o rótulo a encolher. Se houver duas ações, elas se empilham.
 *
 * `primaria` é latão sobre papel; `secundaria` é tinta com fio. Nada de
 * terceira variante colorida: verde e vermelho são do semáforo glicêmico.
 */
export function Botao({
  rotulo,
  icone,
  variante = "primaria",
  desabilitado,
  onClick,
  type = "button",
}: {
  rotulo: string;
  icone?: LucideIcon;
  variante?: "primaria" | "secundaria";
  desabilitado?: boolean;
  onClick?: () => void;
  type?: "button" | "submit";
}) {
  const primaria = variante === "primaria";
  const Icone = icone;
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={desabilitado}
      className="toque flex w-full items-center justify-center gap-3 rounded-xl font-bold disabled:opacity-50"
      style={{
        minHeight: "var(--alvo-min)",
        fontSize: "var(--t-linha)",
        padding: "0 20px",
        ...(primaria
          ? {
              background: "hsl(var(--accent))",
              color: "hsl(var(--accent-foreground))",
            }
          : {
              background: "transparent",
              color: "var(--tinta)",
              border: "2px solid hsl(var(--border))",
            }),
      }}
    >
      {Icone && <Icone className="h-6 w-6 shrink-0" strokeWidth={2.2} />}
      {rotulo}
    </button>
  );
}
